import {Injectable} from "@angular/core";

@Injectable()
export class SignersClickSignEnum {
    signers = [
        { type: 'party', label: 'Parte' },
        { type: 'witness', label: 'Testemunha' }
    ];

    find(signerType) {
        const signer = this.signers.find(s => s.type === signerType);
        if(!signer)
            return '-';
        return signer.label;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/signersClickSign.ts